import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 81,
	height: 35,
	viewBox: "0 0 81.28 33.926",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0 33.998 L 7.113 33.998 L 7.113 21.141 L 0 24.283 L 0 33.998 Z",
			fill: "#6AAFBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 7.103 21.141 L 13.346 19.382 L 13.361 33.926 L 18.401 33.998 L 18.401 7.428 L 22.063 8.792 L 22.063 0 L 7.103 5.549 L 7.103 21.141 Z",
			fill: "#6AAFBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 29.341 11.789 L 29.341 22.858 L 29.341 33.926 L 29.16 33.925 L 28.979 33.923 L 28.979 33.92 L 28.979 33.916 L 26.75 33.896 L 24.52 33.875 L 24.52 21.868 L 24.52 9.86 L 26.75 10.756 L 28.979 11.652 L 29.16 11.721 L 29.341 11.789",
			fill: "#6AAFBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.632 13.064 C 4.632 10.65 2.557 8.691 0 8.691 L 0 17.43 C 2.557 17.437 4.632 15.478 4.632 13.064 Z",
			fill: "#6AAFBF"
		}),
		/* @__PURE__ */ _jsx("text", {
			style: {
				fill: "rgb(0, 0, 0)",
				fontFamily: "Montserrat, sans-serif",
				fontSize: 17,
				fontWeight: "bold"
			},
			transform: "matrix(0.978, 0, 0, 0.880195, 1.138302, 3.016959)",
			x: 13.6,
			y: 26.444,
			children: "EZBuild"
		}),
		/* @__PURE__ */ _jsx("text", {
			style: {
				fill: "rgb(0, 0, 0)",
				fontFamily: "Inter, sans-serif",
				fontSize: "7.1px"
			},
			x: 15,
			y: 33.5,
			children: "Simple.Easy.Smart."
		})
	]
});
export default SvgLogo;
